import { useViewCounter } from "@/modules/viewCounter/stores/viewCounter";

export function installPageViewTracker({ router, pinia }) {
  router.afterEach((to) => {
    if (!to.meta || to.meta.countViews !== true) return;

    const store = useViewCounter(pinia);
    const path = to.path;
    store.track(path);
  });
}
